var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "spacesGuidelines" }, [
      _c("div", { staticClass: "mb-3" }, [
        _vm._v(
          "Follow these guidelines when editing to ensure formatting is correct:"
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _c("ul", [
          _c("li", [
            _vm._v("The “RESOURCEID” field is the "),
            _c("strong", [_vm._v("unique ID")]),
            _vm._v(" per space."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("A "),
            _c("strong", [_vm._v("new")]),
            _vm._v(" unique “RESOURCEID” will "),
            _c("strong", [_vm._v("create")]),
            _vm._v(" a new space."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("An existing “RESOURCEID” will "),
            _c("strong", [_vm._v("update")]),
            _vm._v(" that existing space."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "If using the upload functionality prior to integrating calendar systems, ensure the "
            ),
            _c("strong", [_vm._v("exact calendar resource ID")]),
            _vm._v(
              " is used in the “Space Key” that will be sent via the integration."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "For non-bookable spaces or spaces without a calendar resource ID, input a unique value in the “RESOURCEID” field (recommended to be a number)."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Using the “Building Key” will "),
            _c("strong", [_vm._v("associate all building attributes")]),
            _vm._v(
              " to that space. Obtain Building Key values by downloading your building csv."
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }